<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: ztn-search-box.vue
  - Created by: ChanYing
  - Create Date: 2023-04-06 15:38
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <div class="text-start mb-2">
    <div class="search-box me-2">
      <div :class="disabled ? 'search-disable' : 'search-enable'">
        <img :src="prefixIcon" alt=""/>
        <input
            class="input"
            v-bind="$attrs"
            :placeholder="computedPlaceholder"
            :disabled="disabled"
            v-model="input"
            @input="$emit('update:modelValue', $event.target.value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ztn-search-box",
  props: {
    prefixIcon: {
      type: String,
      default: require('@/assets/images/icon-png/search-icon.svg')
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    computedPlaceholder() {
      return this.placeholder || this.$t('navbar.search.text');
    }
  },
  data() {
    return {
      input: this.modelValue
    }
  },
  watch: {
    modelValue(newValue) {
      this.input = newValue;
    }
  }
}
</script>

<style scoped>
.input {
  border: none;
  width: 100%;
  background-color: var(--body-color) !important;
  color: var(--body-color-1);
  font-family: var(--t400-font-family), sans-serif;
  font-size: var(--t400-font-size);
}

.input::placeholder {
  color: var(--body-aux-1);
}

/* The visible border lives on the wrapper, so the focus ring lives there too
   (:focus-within). The global :focus-visible outline is suppressed on the
   inner borderless input — the wrapper ring below is its replacement. */
.input:focus-visible {
  outline: none;
}

.search-enable:focus-within {
  border-color: var(--base-primary-1);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--ztn-brand-fill) 20%, transparent);
}

.search-enable {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: var(--space-3);
  width: 100%;
  height: var(--control-height-lg);
  background-color: var(--body-color) !important;
  border-radius: var(--radius-md);
  border: 1pt solid var(--line-box-border-1);
  transition: all 0.2s;
}

.search-disable {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: var(--space-3);
  width: 100%;
  height: var(--control-height-lg);
  background: var(--body-aux-4);
  border-radius: var(--radius-md);
  border: 1pt solid var(--line-box-border-1);
  cursor: not-allowed;
  transition: all 0.2s;
}

.search-disable .input {
  background-color: var(--body-aux-4) !important;
  color: var(--body-aux-2) !important;
  cursor: not-allowed;
}

.search-disable img {
  filter: grayscale(70%) opacity(0.65);
}

.search-disable .input::placeholder {
  color: var(--body-aux-2);
}
</style>